import React from "react";

import Fluid from 'components/Fluid';
import Link from "components/Link";
import { Box, Typography } from '@mui/material';
import { ReactComponent as ArrowUpRight } from 'images/icons/arrow_up_right.svg';

const CallOut = ({ preTitle, title, description, link, linkText, image, imageSide = 'left', flush, padding, background, backgroundImage, backgroundProps }) => {
	const sectionInlineStyle = {
		...(backgroundImage ? {
			backgroundImage: `url(${process.env.CDN_DOMAIN||''}${backgroundImage}?max-w=1920&format=webp)`,
			...(backgroundProps ? {
				...(backgroundProps.indexOf('cover') !== -1 ? {
					backgroundSize: 'cover',
				} : null),
				...(backgroundProps.indexOf('fixed') !== -1 ? {
					backgroundAttachment: 'fixed',
				} : null),
				...(backgroundProps.indexOf('repeat') !== -1 ? {
					backgroundRepeat: 'repeat',
				} : {backgroundRepeat: 'no-repeat'}),
			} : null),
		} : null),
	}

	const [gridLayout, setGridLayout] = React.useState({xs: '12', ms: '4 6'});

	React.useEffect(() => {
		if (imageSide === 'right') {
			setGridLayout({xs: '12', ms: '6 4'})
		}
	}, [imageSide]);

	const ImageBox = ({image}) => {
		if (!image) return null;
		return (
			<Box className={['callOut__image_wrapper'].join(' ')}>
				<Box className={['callOut__image'].join(' ')} sx={{
					backgroundImage: `url(${image}?max-w=800&format=webp)`,
				}} />
			</Box>
		)
	}

	// imageSide = 'none';

	return (
		<Box sx={(Object.keys(sectionInlineStyle).length > 0 ? sectionInlineStyle : null)} className={[
			"callOut__section",
			(padding ? 'padding-large' : ''), 
			(flush ? 'margin-flush' : ''),
			(background||'')
		].join(' ')}>
			<Fluid layout={gridLayout} className={[`callOut__image_${imageSide}`].join(' ')} justifyContent={'center'} alignItems={'center'} gap={{ sm: undefined, ms: '40px', xl: '80px' }}>
				{imageSide === 'left' && <ImageBox image={image} />}
				<div className={['callOut__content'].join(' ')}>
					{preTitle && <Typography component="div" variant="h6" className="callOut__pre-title">{preTitle}</Typography>}
					<Typography component="div" variant="h3" className="callOut__title">{title}</Typography>
					{description && <Typography component="div" variant="h4" className="callOut__body">{description}</Typography>}
					<Link className="callOut__link" href={link}>
						<span className="callOut__linkText">
							<span className="callOut__linkText__label">{linkText}</span>
							<span className="callOut__linkText__arrow" aria-hidden="true">
								<ArrowUpRight />
							</span>
						</span>
					</Link>
				</div>
				{imageSide === 'right' && <ImageBox image={image} />}
			</Fluid>
		</Box>
	);
};

export default CallOut;